import { combineReducers } from 'redux';
import dramaPinnedComments from './dramaPinnedComments';
import dramaComments from './dramaComments';
import dramaCommentReplies from './dramaCommentReplies';
import dramaCommentUsers from './dramaCommentUsers';
import dramas from './dramas';
import dramaInfo from './dramaInfo';
import dramaSeoInfo from './dramaSeoInfo';
import deal from './deal';
import packageSubscription from './packageSubscription';
import subscribedPackages from './subscribedPackages';
import watchHistory from './watchHistory';
import favoriteDramas from './favoriteDramas';
import categories from './categories';
import policy from './policy';

export default combineReducers({
  dramaPinnedComments,
  dramaComments,
  dramaCommentReplies,
  dramaCommentUsers,
  dramas,
  dramaInfo,
  dramaSeoInfo,
  deal,
  packageSubscription,
  subscribedPackages,
  watchHistory,
  favoriteDramas,
  categories,
  policy,
});
